module.exports = __webpack_public_path__ + "static/media/undraw_profile.1da2f226.svg";